// @flow

import { themes } from '@ansarada/mui-themes-old';
import { GlobalStyles, ThemeProvider } from '@mui/material';
import 'app/sass/styles.scss';
import 'focus-visible';

import { render } from 'react-dom';
import { Route, Router, Switch } from 'react-router-dom';
import history from './history';
import SecureSharingPage from './secure-sharing-page';

const CustomGlobalStyles = () => (
  <GlobalStyles
    styles={{
      body: { margin: 0 },
    }}
  />
);

const SecureSharing = () => {
  const content = (
    <Switch>
      <Route path="" component={SecureSharingPage} />
    </Switch>
  );

  return (
    <ThemeProvider theme={themes.ACELight}>
      <Router history={history}>{content}</Router>
      <CustomGlobalStyles />
    </ThemeProvider>
  );
};

const spaRootElement = document.querySelector('#spa-root');

export default function renderApp() {
  render(<SecureSharing />, spaRootElement);
}

renderApp();
